
import { defineComponent, reactive, toRefs } from "vue";
import { deletePeripheral, updatePeripheralStatus } from "../composables/api";
import { formatDate } from "@/composables/utils";
import { PeipheralsTableDataType } from "@/types/components";
import { openNotificationWithIcon } from "@/composables/utils";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons-vue";
import CreatePeripheralModal from "./CreatePeripheralModal.vue";

import { Table, Button, Switch, Popconfirm } from "ant-design-vue";
import "ant-design-vue/lib/table/style/css";
import "ant-design-vue/lib/popconfirm/style/css";
import "ant-design-vue/lib/switch/style/css";
import { Peripheral } from "@/types";

export default defineComponent({
  name: "PeripheralsTable",
  components: {
    ATable: Table,
    AButton: Button,
    PlusOutlined,
    DeleteOutlined,
    CreatePeripheralModal,
    ASwitch: Switch,
    APopconfirm: Popconfirm,
  },
  props: {
    peripherals: {
      type: Array,
      required: true,
    },
    gatewayId: {
      type: String,
      required: true,
    },
  },
  emits: ["refresh"],
  setup(props, ctx) {
    const data: PeipheralsTableDataType = reactive({
      columns: [
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
        },
        {
          title: "UID",
          dataIndex: "uid",
          key: "uid",
        },
        {
          title: "Vendor",
          dataIndex: "vendor",
          key: "vendor",
        },
        {
          title: "Created At",
          dataIndex: "createdAt",
          key: "createdAt",
        },
        {
          title: "Actions",
          key: "actions",
        },
      ],
      isLoading: false,
      createPeripheralModalVisibility: false,
      updatingStatusIDs: [],
    });

    const peripheralCreated = async () => {
      data.createPeripheralModalVisibility = false;
      ctx.emit("refresh");
    };

    const onDeletePeripheral = async (peripheral: Peripheral) => {
      try {
        data.isLoading = true;
        await deletePeripheral(peripheral._id);
        openNotificationWithIcon("success", "Peripheral succesfully deleted");
        ctx.emit("refresh");
      } catch (error) {
        console.log("Error while deleting gateway: ", error);
      } finally {
        data.isLoading = false;
      }
    };

    const onUpdatePeripheralStatus = async (peripheral: Peripheral) => {
      try {
        data.updatingStatusIDs.push(peripheral._id);
        await updatePeripheralStatus(peripheral._id, peripheral.status);
        openNotificationWithIcon(
          "success",
          "Peripheral status succesfully updated"
        );
        ctx.emit("refresh");
      } catch {
        console.log("Error while updating status");
      } finally {
        const index = data.updatingStatusIDs.indexOf(peripheral._id);
        data.updatingStatusIDs.splice(index, 1);
      }
    };

    return {
      ...toRefs(data),
      props,
      peripheralCreated,
      onDeletePeripheral,
      formatDate,
      onUpdatePeripheralStatus,
    };
  },
});
